/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SystemControllerDtoMnSubLnbListRequest model module.
 * @module model/SystemControllerDtoMnSubLnbListRequest
 * @version 1.0
 */
class SystemControllerDtoMnSubLnbListRequest {
    /**
     * Constructs a new <code>SystemControllerDtoMnSubLnbListRequest</code>.
     * @alias module:model/SystemControllerDtoMnSubLnbListRequest
     * @param gnbNo {Number} 
     * @param lnbNo {Number} 
     */
    constructor(gnbNo, lnbNo) { 
        
        SystemControllerDtoMnSubLnbListRequest.initialize(this, gnbNo, lnbNo);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, gnbNo, lnbNo) { 
        obj['gnbNo'] = gnbNo;
        obj['lnbNo'] = lnbNo;
    }

    /**
     * Constructs a <code>SystemControllerDtoMnSubLnbListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SystemControllerDtoMnSubLnbListRequest} obj Optional instance to populate.
     * @return {module:model/SystemControllerDtoMnSubLnbListRequest} The populated <code>SystemControllerDtoMnSubLnbListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SystemControllerDtoMnSubLnbListRequest();

            if (data.hasOwnProperty('gnbNo')) {
                obj['gnbNo'] = ApiClient.convertToType(data['gnbNo'], 'Number');
            }
            if (data.hasOwnProperty('lnbNo')) {
                obj['lnbNo'] = ApiClient.convertToType(data['lnbNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SystemControllerDtoMnSubLnbListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SystemControllerDtoMnSubLnbListRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of SystemControllerDtoMnSubLnbListRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

SystemControllerDtoMnSubLnbListRequest.RequiredProperties = ["gnbNo", "lnbNo"];

/**
 * @member {Number} gnbNo
 */
SystemControllerDtoMnSubLnbListRequest.prototype['gnbNo'] = undefined;

/**
 * @member {Number} lnbNo
 */
SystemControllerDtoMnSubLnbListRequest.prototype['lnbNo'] = undefined;






export default SystemControllerDtoMnSubLnbListRequest;

